import api from "./api";

// Every booking guests made on this host's listings (homes, hotels,
// experiences and event tickets) as one list.

const KIND_LABELS = { home: "Home", hotel: "Hotel", experience: "Experience", event: "Event" };
export const kindLabel = (kind) => KIND_LABELS[kind] || kind;

const guestOf = (b) => ({
  name: b.names || "Guest",
  email: b.email || "",
  phone: b.phone_number || "",
});

const stay = (kind, titleKey) => (b) => ({
  key: `${kind}-${b.id}`,
  id: String(b.id),
  kind,
  listing: b[titleKey],
  guest: guestOf(b),
  start: b.check_in_date,
  end: b.check_out_date,
  status: b.status || "confirmed",
  guests: b.number_of_guests,
  nights: b.nights_to_stay,
  amount: b.amount_paid,
  currency: b.currency,
  reference: b.payment_ref,
  method: b.payment_method,
  createdAt: b.created_at,
});

const experience = (b) => ({
  key: `experience-${b.id}`,
  id: String(b.id),
  kind: "experience",
  listing: b.experience_title,
  guest: guestOf(b),
  start: b.check_in_date,
  end: null,
  status: b.status || "confirmed",
  guests: b.number_of_guests,
  amount: b.amount_paid,
  currency: b.currency,
  reference: b.payment_ref,
  method: b.payment_method,
  createdAt: b.created_at,
});

const eventBooking = (b) => ({
  key: `event-${b.id}`,
  id: String(b.id),
  kind: "event",
  listing: b.event_name,
  guest: guestOf(b),
  start: b.check_in_date,
  end: null,
  status: b.status || "confirmed",
  guests: b.number_of_tickets,
  ticket: b.ticket,
  amount: b.amount_paid,
  currency: b.currency,
  reference: b.payment_ref,
  method: b.payment_method,
  createdAt: b.created_at,
});

// Each source fails on its own so one broken endpoint doesn't hide the rest.
const safeGet = (url) =>
  api
    .get(url)
    .then((res) => res.data?.data || [])
    .catch(() => null);

export async function fetchHostBookings() {
  const [homes, hotels, experiences, events] = await Promise.all([
    safeGet("homes/host/bookings"),
    safeGet("hotels/host/bookings"),
    safeGet("experiences/host/bookings"),
    safeGet("events/host/bookings"),
  ]);
  const failed = [
    homes === null && "homes",
    hotels === null && "hotels",
    experiences === null && "experiences",
    events === null && "events",
  ].filter(Boolean);
  const items = [
    ...(homes || []).map(stay("home", "home_title")),
    ...(hotels || []).map(stay("hotel", "hotel_title")),
    ...(experiences || []).map(experience),
    ...(events || []).map(eventBooking),
  ];
  return { items, failed };
}

/** Over once its last day has ended. */
export function isPast(booking, now = new Date()) {
  const last = booking.end || booking.start;
  if (!last) return false;
  const end = new Date(last);
  end.setHours(23, 59, 59, 999);
  return end < now;
}

export function formatDay(value) {
  if (!value) return "";
  return new Date(value).toLocaleDateString([], { day: "numeric", month: "short", year: "numeric" });
}

export function money(amount, currency) {
  if (amount === undefined || amount === null || amount === "") return "";
  return `${currency || "UGX"} ${Number(amount).toLocaleString()}`;
}
